export const checkIfIsInteger = (value: unknown): value is number => {
  if (typeof value !== 'number') {
    return false;
  }

  return Number.isInteger(value);
};
